import {useEffect} from "react";
import '../../../static/css/home/bank.css';

export const HomeNahalBankScreen = () => {
    useEffect(() => {
        document.title = "بانک نهال | مدرسه هوشمند نهال";
    }, []);
    return (
        <>
            <div className="nahal-bank-hero">
                <div className="nahal-bank-hero-overlay">
                    <div className="container">
                        <div className="row align-items-center">
                            <div className="col-lg-6 d-lg-none">
                                <img src="/svg/bank.svg" alt="بانک نهال"/>
                                <div style={{height:30}}/>
                            </div>
                            <div className="col-lg-6">
                                <h1 data-aos="fade-up" data-aos-duration={1000}>بانک نهال</h1>
                                <p data-aos="fade-up" data-aos-duration={1000} data-aos-delay={100}>با هدف آموزش مهارت سرمایه‌گذاری در مدرسه هوشمند و مهارتی نهال، دانش‌آموزان می‌توانند
                                    از امکانات بانک نهال داخل مدرسه استفاده نمایند.</p>
                            </div>
                            <div className="col-lg-6 d-none d-lg-inline-block">
                                <img data-aos="zoom-in-up" data-aos-duration={1000} data-aos-delay={200} src="/svg/bank.svg" alt="بانک نهال"/>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="nahal-bank-cards">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-md-6">
                            <img src="/images/bank/1.jpg" alt=""/>
                        </div>
                        <div className="col-md-6">
                            <img src="/images/bank/2.jpg" alt=""/>
                        </div>
                        <div className="col-md-6">
                            <img src="/images/bank/3.jpg" alt=""/>
                        </div>
                        <div className="col-md-6">
                            <img src="/images/bank/4.jpg" alt=""/>
                        </div>
                        <div className="col-md-6">
                            <img src="/images/bank/5.jpg" alt=""/>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};